// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__2Onok","row":"styles_row__3WkG2"};